import { useContext, createContext } from 'react';
export const StateContext = createContext();

const useGlobalState = () => useContext(StateContext);
export default useGlobalState;
